// src/components/TheFormulaHandout.jsx
import React from 'react';
import { FaDownload, FaEnvelope } from "react-icons/fa"; // Importa el ícono de descarga y el de sobre

const TheFormulaHandout = () => {
  // ID genérico de YouTube. ¡Cámbialo por el video real de "La Fórmula"!
  const youtubeVideoId = "BmVJK5S4RKQ"; // Ejemplo: Rick Astley. ¡CAMBIA ESTE ID!
  const pdfDownloadUrl = "https://gusaguiar.com/assets/la_formula.pdf";
  const newsletterUrl = "/metafisica/bashar";

  // Clase común para títulos de sección interactivos
  const interactiveTitleClasses = "text-2xl sm:text-3xl font-bold mb-4 text-purple-300 transition-all duration-300 ease-in-out hover:text-purple-100 hover:scale-105";
  // Clase común para elementos de lista interactivos
  const interactiveListItemClasses = "transition-all duration-200 ease-in-out hover:text-white hover:translate-x-1";

  return (
    <div className="bg-black text-white min-h-screen font-sans flex flex-col items-center py-12 px-4">
      {/* Fondo gradiente similar al HomePage */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950 via-black to-gray-900 opacity-95"></div>

      <main className="relative z-10 container mx-auto max-w-3xl">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-center mb-10 text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600 animate-fade-in-up">
          "LA FÓRMULA"
        </h1>

        {/* Video de YouTube explicando la fórmula */}
        <div className="w-full max-w-2xl mx-auto mb-12 animate-fade-in delay-100">
          <h2 className="text-2xl sm:text-3xl font-bold text-center mb-6 text-purple-300">
            Mira este video para entender "La Fórmula"
          </h2>
          <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
            <iframe
              className="absolute top-0 left-0 w-full h-full rounded-xl shadow-lg border border-gray-700 transform transition-all duration-300 hover:scale-[1.01]"
              src={`https://www.youtube.com/embed/${youtubeVideoId}`}
              title="Explicación de La Fórmula"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
          <p className="text-xs text-gray-500 text-center mt-2">
            Este video es un placeholder. Reemplaza el ID de YouTube para mostrar el video correcto.
          </p>
        </div>

        <section className="mb-12 animate-fade-in delay-200">
          <h2 className={interactiveTitleClasses}>
            1. ACTÚA SOBRE LA OPORTUNIDAD QUE CONTENGA LA MAYOR EXCITACIÓN.
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-lg text-gray-200">
            <li className={interactiveListItemClasses}>La mayor excitación no tiene por qué presentarse en forma de proyecto o carrera.</li>
            <li className={interactiveListItemClasses}>
              Mientras una opción contenga incluso un poco más de excitación que cualquier otra,
              actúa sobre ella primero.
            </li>
            <li className={interactiveListItemClasses}>
              La excitación es la traducción física de tu cuerpo de una comunicación de tu mente superior.
              Responde a ella actuando sobre la excitación.
            </li>
            <li className={interactiveListItemClasses}>
              Revisa tus creencias para asegurarte de no estar haciendo que la ansiedad parezca excitación.
              Revisa tus creencias para asegurarte de no estar haciendo que la excitación parezca ansiedad
              a través de definiciones basadas en el miedo.
            </li>
          </ul>
        </section>

        <section className="mb-12 animate-fade-in delay-300">
          <h2 className={interactiveTitleClasses}>
            2. ACTÚA SOBRE ESA EXCITACIÓN CON LA MEJOR DE TUS HABILIDADES.
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-lg text-gray-200">
            <li className={interactiveListItemClasses}>Utiliza todas tus habilidades, talentos, imaginación y capacidades al tomar la acción.</li>
            <li className={interactiveListItemClasses}>Actúa al máximo grado que seas capaz de actuar.</li>
            <li className={interactiveListItemClasses}>
              Si más de una oportunidad tiene la misma capacidad de ser ejecutada, elige cualquiera y te mostrará
              si debes o no continuar por ese camino.
            </li>
            <li className={interactiveListItemClasses}>Sigue actuando hasta que no tengas más capacidad para actuar.</li>
            <li className={interactiveListItemClasses}>
              Cuando no puedas actuar más, elige la siguiente cosa más excitante sobre la que seas capaz de tomar acción.
            </li>
            <li className={interactiveListItemClasses}>
              Reconoce las señales, reflejos y acuerdos que indican una incapacidad para tomar acción.
            </li>
            <li className={interactiveListItemClasses}>
              Los parámetros físicos, las leyes de la sociedad, los valores morales y los estándares éticos
              pueden indicar si tienes o no la capacidad de tomar acción.
            </li>
          </ul>
        </section>

        <section className="mb-12 animate-fade-in delay-400">
          <h2 className={interactiveTitleClasses}>
            3. ACTÚA SOBRE ESA EXCITACIÓN CON ABSOLUTAMENTE CERO INSISTENCIA O SUPOSICIÓN CON
            RESPECTO A UN RESULTADO ESPECÍFICO.
          </h2>
          <ul className="list-disc pl-6 space-y-3 text-lg text-gray-200">
            <li className={interactiveListItemClasses}>
              Comprende que la insistencia en un resultado, manifestación o camino específico
              puede, de hecho, impedir una manifestación mejor de lo que imaginaste.
            </li>
            <li className={interactiveListItemClasses}>
              Puede que la cosa misma que te excita no necesite materializarse. Puede que solo te excite
              para que tomes acción con el fin de crear el estado del ser en el que lo que realmente
              necesita manifestarse pueda hacerlo.
            </li>
          </ul>
        </section>

        <section className="mt-12 p-6 bg-gray-800 rounded-xl shadow-lg border border-gray-700 animate-fade-in delay-500">
          <p className="text-xl font-semibold mb-4 text-center text-purple-200">
            Actuar sobre esta fórmula de tres partes con integridad te alinea con el kit de herramientas
            completo de excitación que:
          </p>
          <ul className="list-disc pl-6 space-y-3 text-lg text-gray-200">
            <li className={interactiveListItemClasses}>Proporciona toda forma de apoyo, abundancia o información que necesites.</li>
            <li className={interactiveListItemClasses}>Se convierte en el motor impulsor que te lleva adelante.</li>
            <li className={interactiveListItemClasses}>Actúa como el principio organizador que te muestra sobre qué actuar, en qué orden y cuándo.</li>
            <li className={interactiveListItemClasses}>Te presenta el camino de menor resistencia para fluir a través de la vida.</li>
            <li className={interactiveListItemClasses}>
              Te conecta con todas las demás expresiones de tu excitación, sin importar la forma en que se presenten.
            </li>
            <li className={interactiveListItemClasses}>
              Se convierte en el espejo reflectante que revela cualquier cosa dentro de tus creencias
              que esté desalineada con tu verdadera vibración de excitación.
            </li>
            <li className={interactiveListItemClasses}>No deja nada relevante fuera.</li>
          </ul>
        </section>

        {/* Botón de descarga del PDF */}
        <a
          href={pdfDownloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          download="La_Formula_Handout.pdf"
          className="w-full max-w-md mx-auto mt-12 flex items-center justify-center px-4 py-3 rounded-xl border border-purple-600 bg-purple-700/50 text-white font-medium text-base sm:text-lg shadow-md shadow-purple-700/30 hover:bg-purple-600 hover:border-purple-500 transition-all duration-300 ease-in-out"
        >
          <FaDownload className="mr-3 text-xl" />
          Descarga "La Fórmula" (PDF)
        </a>

        {/* Nuevo botón para suscribirse a la newsletter de Bashar */}
        <a
          href={newsletterUrl}
          className="w-full max-w-md mx-auto mt-6 flex items-center justify-center px-4 py-3 rounded-xl border border-blue-500 bg-blue-600/50 text-white font-medium text-base sm:text-lg shadow-md shadow-blue-600/30 hover:bg-blue-500 hover:border-blue-400 transition-all duration-300 ease-in-out"
        >
          <FaEnvelope className="mr-3 text-xl" />
          Enterate de nuestro próximo contenido de Bashar
        </a>
      </main>
    </div>
  );
};

export default TheFormulaHandout;